import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ArthritisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Arthritis</h1>
        <section className="mb-8">
          <p>Arthritis is a common condition that causes pain, swelling, and stiffness in the joints. It can affect people of all ages and may limit mobility and daily activities. Natural therapies can help reduce inflammation, relieve pain, and support joint health for long-term comfort.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Osteoarthritis (wear and tear of joints)</li>
            <li>Rheumatoid arthritis (autoimmune)</li>
            <li>Injury or overuse</li>
            <li>Aging</li>
            <li>Genetic predisposition</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Joint pain and swelling</li>
            <li>Stiffness, especially in the morning</li>
            <li>Reduced range of motion</li>
            <li>Warmth or redness in joints</li>
            <li>Fatigue</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, soothing oils, and gentle therapies to reduce pain and swelling, restore mobility, and support long-term joint health. Each plan is tailored to your needs for safe, effective relief.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces pain and inflammation</li>
            <li>Improves joint flexibility</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a healthy weight</li>
            <li>Practice regular, gentle exercise</li>
            <li>Use supportive footwear</li>
            <li>Eat an anti-inflammatory diet</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help with chronic arthritis?</strong>
            <p>A: Yes, our approach is effective for both osteoarthritis and rheumatoid arthritis.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for seniors?</strong>
            <p>A: Absolutely, our therapies are gentle and suitable for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I feel relief?</strong>
            <p>A: Many patients notice improvement within a few sessions.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Move freely again—book your natural arthritis consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ArthritisPage; 